export const validateEmailRegex = (user_email: string, withoutSpecialChar?: boolean) => {
    var regex = withoutSpecialChar ?
        /^[a-zA-Z0-9!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/ :
        /^[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/;
    return regex.test(user_email);
}

export const validateMinLength = (str: string, minLength?: number) => {
    minLength = minLength || 4;
    if (str?.trim()?.length < minLength) {
        return false;
    }
    return true;
}

export const validateDobYear = (dobYear: any) => {
    dobYear = parseInt(dobYear);
    var date = new Date();
    var current_year = date.getFullYear() - 1;
    var min_allowed_year = /(19|20)\d{2}$/;
    // @ts-ignore
    var is_europe_teacher = window?.is_europe_teacher
    if (dobYear > current_year || !min_allowed_year.test(dobYear)) {
        return "Please enter a valid Year of Birth";
    }
    if (is_europe_teacher && dobYear > current_year - 18) {
        return "Age should be greater than 18 years";
    } else if (!is_europe_teacher && dobYear > current_year - 13) {
        return "Age should be greater than 13 years"
    }
    return false;
}

export const getSignupMethod = () => {
    var signupMethod = 'manual';
    const authSignupMethod = localStorage.getItem('parent_signup_method');
    if (authSignupMethod) {
        signupMethod = authSignupMethod;
    }
    return signupMethod;
}

let loadingSpinnerCount = 0;
export const GlobalSpinner = {
    show: () => {
        loadingSpinnerCount++;
        const element = document.getElementById('ajax-spinner-id') || document.getElementById('spinner');
        if (element) {
            if (!element.hasAttribute('data-test-id')) {
                element.setAttribute('data-test-id', 'bubble-wait-icon');
            }
            (element as HTMLElement).style.display = 'block';
        }
    },
    hide: () => {
        loadingSpinnerCount--;
        if (loadingSpinnerCount <= 0) {
            loadingSpinnerCount = 0;
            const element = document.getElementById('ajax-spinner-id') || document.getElementById('spinner');
            if (element) {
                (element as HTMLElement).style.display = 'none';
            }
        }
    }
};